var _path, _g, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1692 34.9701C12.0625 34.9179 9.51372 33.6581 6.76122 30.7249C4.23546 28.033 1.04159 23.3489 0.16612 16.3185L0 14.9799L1.34473 15.0866C1.42718 15.0926 1.51206 15.0963 1.59451 15.0963C3.34181 15.0963 5.09516 13.6655 5.95729 11.5362C6.71393 9.66644 6.6824 7.51052 5.87484 5.91115L5.0697 4.31664H6.8558C8.79346 4.31664 11.0767 2.00914 11.7933 1.12034L12.6955 -6.10352e-05L13.5394 1.1652C14.176 2.03825 16.2895 4.30815 18.3836 4.30815H20.1721L19.3633 5.90388C18.5521 7.50445 18.5194 9.6628 19.2784 11.5362C20.1406 13.6655 21.8939 15.0963 23.6412 15.0963C23.7394 15.0963 23.8377 15.0914 23.9347 15.0829L25.3 14.9556L25.1266 16.3161C24.2426 23.258 21.0524 27.9457 18.5327 30.6558C15.7887 33.6072 13.2508 34.907 13.1441 34.9604L12.6579 35.2065L12.168 34.9677L12.1692 34.9701Z",
    fill: "url(#paint0_linear_5570_110302)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5570_110302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2615 11.9509C17.3472 9.69195 17.4612 7.23409 18.3852 5.40919C15.2531 5.40919 12.651 1.81154 12.651 1.81154C12.651 1.81154 9.74571 5.41647 6.8574 5.41647C7.77773 7.24016 7.88928 9.69437 6.97744 11.9497C5.85219 14.7301 3.51196 16.361 1.25781 16.1828C2.88264 29.2238 12.651 33.9819 12.651 33.9819C12.651 33.9819 22.3987 29.0565 24.0393 16.1791C21.7682 16.3901 19.3977 14.7544 18.2627 11.9497L18.2615 11.9509Z",
    fill: "url(#paint1_radial_5570_110302)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2013 14.1516C17.8278 13.6108 17.504 13.0118 17.2409 12.3631C16.4382 10.3781 16.3157 8.20037 16.8638 6.29059C15.0304 5.7704 13.5135 4.42931 12.6199 3.47867C11.6886 4.4184 10.1341 5.74857 8.36621 6.2821C8.91793 8.19309 8.79667 10.3757 7.99153 12.3631C6.91963 15.0113 4.83282 16.8313 2.51562 17.2194C2.93759 19.7197 3.69787 22.0369 4.78553 24.1564C7.33675 19.756 12.1458 16.1814 18.1988 14.1516H18.2013Z",
    fill: "url(#paint2_linear_5570_110302)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.1,
    d: "M18.2627 11.9509C17.3484 9.69195 17.4624 7.23409 18.3864 5.40919C15.2544 5.40919 12.6522 1.81154 12.6522 1.81154C12.6522 1.81154 12.6449 1.82124 12.6328 1.83458V33.971C12.6449 33.977 12.6522 33.9807 12.6522 33.9807C12.6522 33.9807 22.4 29.0553 24.0406 16.1779C21.7694 16.3889 19.3989 14.7532 18.2639 11.9485L18.2627 11.9509Z",
    fill: "url(#paint3_linear_5570_110302)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59897 19.9921L6.69426 21.6763L6.17969 22.1319L7.38933 20.1792L6.87985 18.7832L8.50799 16.9229C8.58077 16.8501 8.55166 16.9891 8.46796 17.2344C8.23433 17.92 7.57784 19.4346 7.57784 19.4346L8.59897 19.9921Z",
    fill: "#935530"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69531 21.6763L7.62329 20.1792L7.11381 18.7832L8.46901 17.2344C8.23538 17.92 7.57889 19.4346 7.57889 19.4346L8.6022 19.9929L6.69531 21.6763Z",
    fill: "#692A05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56767 16.9603L7.75106 19.3141L8.59897 19.9924L6.17969 22.1322L8.39445 20.004L7.57565 19.4341L8.56767 16.9603Z",
    fill: "#935530"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5570_110302",
    x: 1.09082,
    y: 1.81154,
    width: 23.1152,
    height: 33.0888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.751485
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0834984
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0509804 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5570_110302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5570_110302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5570_110302",
    x1: 0.00000110448,
    y1: -3.971,
    x2: 24.0058,
    y2: 38.2374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#692A05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395172,
    stopColor: "#E7C39C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645028,
    stopColor: "#C16F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#692A05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5570_110302",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6474 17.8973) scale(13.9371 13.4297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "#D9A677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3614"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5570_110302",
    x1: 15.6755,
    y1: 6.98296,
    x2: 4.26898,
    y2: 22.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5570_110302",
    x1: 12.6316,
    y1: 17.8973,
    x2: 24.0393,
    y2: 17.8973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#919190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#525251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B2B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1D1D1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d3e60ea26744851372e82b15d11c69ec.svg";
export { ForwardRef as ReactComponent };